import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import { objectAsParams } from "../../../helpers";
import Http from '../../../Http';
// import {FormGroup} from '../../form/FormOpsV2'

class Zona extends FormComponent {

  componentDidMount() {
    const disabled = false
    this.FormConfig(
      { defaultUrl: 'zona/one', saveUrl: 'zona/save', backUrl: '/Catalogo/Zonas' },
      new Form([
        Form.Field('text', 'zona', 'Clave', '', [Validators.required], 2, [],[],[],false, disabled),
        Form.Field('text', 'zona_descripcion', 'Nombre del lugar', '', [Validators.required], 10, [],[],[],false, disabled),
        Form.Field('select', 'id_zona_tipo', 'Tipo', '1', [Validators.required], 6, [],[],[],false, disabled),
        Form.Field('select', 'id_estado', 'Estados', '', [Validators.required], 6, [],[],[],false, disabled),
        Form.Field('select_multiple', 'id_ciudades', 'Municipios', [], [Validators.required], 12, [],[],[],false, disabled),
      ], ['Guardar'], 'Zona'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    const params = {}
    if (this.formIdEstado) {
      params['id_estado'] = this.formIdEstado;
      this.formIdEstado = null;
    }
    
    if (this.props.match.params.id) {
      params['id_zona'] = this.props.match.params.id;
    }

    let Res = await Http.get(`zona/form?${objectAsParams(params)}`);
    if (!Res.error) {
      const { Tipos, Estados, Ciudades } = Res.data;
      // this.setState({ FormData: Form.Patch(this.state.FormData, { id_zona_tipo: 1 }) })
      let newForm = Form.FieldOptions(form, 'id_zona_tipo', Tipos, 'id', 'zona_tipo');
      newForm = Form.FieldOptions(newForm, 'id_estado', Estados, 'id', 'estado');
      newForm = Form.FieldOptions(newForm, 'id_ciudades', Ciudades, 'id', 'ciudad');

      newForm = Form.ValueChange(newForm, {
        id_estado: async (field) => { this.fieldChange(field, 'formIdEstado') },
      })
      return newForm;
    }
  }

  fieldChange = async (field, variable) => {
    this[variable] = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) })
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Zona)
